// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
let Scroll = require("../../../reason/common/Scroll/Scroll.bs.js");
let Sentry = require("../../../reason/Sentry.bs.js");
let Scalars = require("../../../scalars/Scalars.bs.js");
let PageTitle = require("../../../reason/common/PageTitle.bs.js");
let PageViews = require("../../../reason/PageViews.bs.js");
let FeaturesV3 = require("../../../reason/featureFlipper/FeaturesV3.bs.js");
let AuthSession = require("../../../utils/AuthSession.bs.js");
let UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let LoggedInAgent = require("../../../reason/common/UserSession/LoggedInAgent.bs.js");
let MarkupHelpers = require("../../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let ErrorComponent = require("../../../reason/common/Error/ErrorComponent.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let ReactErrorBoundary = require("react-error-boundary");
let VisuallyHidden = require("@reach/visually-hidden").default;
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let RentalPropertySearchResult = require("../../property/RentalPropertySearchResult.bs.js");
let UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let DevelopmentUnitSearchResult = require("./DevelopmentUnitSearchResult.bs.js");
let ForSalePropertySearchResult = require("../../property/ForSalePropertySearchResult.bs.js");
let PropertiesPageRelayControls = require("./PropertiesPageRelayControls.bs.js");
let SearchPagesSharedComponents = require("../../common/SearchPagesSharedComponents.bs.js");
let DevelopmentProjectSearchResult = require("./DevelopmentProjectSearchResult.bs.js");
let PropertiesPageRelayQueryParams = require("./PropertiesPageRelayQueryParams.bs.js");
let PropertiesPageRelayQuery_graphql = require("../../../__generated__/PropertiesPageRelayQuery_graphql.bs.js");
let PropertyPage__FreePlanUpgradeBox = require("../../propertyPage/PropertyPage__FreePlanUpgradeBox.bs.js");
let PropertiesPageRelaySharedComponents = require("./PropertiesPageRelaySharedComponents.bs.js");
let PropertiesPageRelayRefetchQuery_graphql = require("../../../__generated__/PropertiesPageRelayRefetchQuery_graphql.bs.js");
let PropertiesPageRelayRental_query_graphql = require("../../../__generated__/PropertiesPageRelayRental_query_graphql.bs.js");
let PropertiesPageRelayWrapperQuery_graphql = require("../../../__generated__/PropertiesPageRelayWrapperQuery_graphql.bs.js");
let PropertiesPageRelayForSale_query_graphql = require("../../../__generated__/PropertiesPageRelayForSale_query_graphql.bs.js");
let PropertiesPageRelayInventory_query_graphql = require("../../../__generated__/PropertiesPageRelayInventory_query_graphql.bs.js");
let PropertiesPageRelayRentalRefetchQuery_graphql = require("../../../__generated__/PropertiesPageRelayRentalRefetchQuery_graphql.bs.js");
let PropertiesPageRelayInventoryRefetchQuery_graphql = require("../../../__generated__/PropertiesPageRelayInventoryRefetchQuery_graphql.bs.js");
let PropertiesPageRelay_RecordPropertySearchEventMutation_graphql = require("../../../__generated__/PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.bs.js");

let convertVariables = PropertiesPageRelayQuery_graphql.Internal.convertVariables;

let convertResponse = PropertiesPageRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = PropertiesPageRelayQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, PropertiesPageRelayQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, PropertiesPageRelayQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(PropertiesPageRelayQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(PropertiesPageRelayQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(PropertiesPageRelayQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(PropertiesPageRelayQuery_graphql.node, convertVariables);

let Query_forSalePropertyTypeEnumV5_decode = PropertiesPageRelayQuery_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let Query_forSalePropertyTypeEnumV5_fromString = PropertiesPageRelayQuery_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let Query_forSalePropertyV5FilterableStatus_decode = PropertiesPageRelayQuery_graphql.Utils.forSalePropertyV5FilterableStatus_decode;

let Query_forSalePropertyV5FilterableStatus_fromString = PropertiesPageRelayQuery_graphql.Utils.forSalePropertyV5FilterableStatus_fromString;

let Query_propertySearchSortOrder_decode = PropertiesPageRelayQuery_graphql.Utils.propertySearchSortOrder_decode;

let Query_propertySearchSortOrder_fromString = PropertiesPageRelayQuery_graphql.Utils.propertySearchSortOrder_fromString;

let Query_rentalPropertyFilterableStatus_decode = PropertiesPageRelayQuery_graphql.Utils.rentalPropertyFilterableStatus_decode;

let Query_rentalPropertyFilterableStatus_fromString = PropertiesPageRelayQuery_graphql.Utils.rentalPropertyFilterableStatus_fromString;

let Query_rentalPropertyTypeEnumV5_decode = PropertiesPageRelayQuery_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let Query_rentalPropertyTypeEnumV5_fromString = PropertiesPageRelayQuery_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let Query = {
  forSalePropertyTypeEnumV5_decode: Query_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: Query_forSalePropertyTypeEnumV5_fromString,
  forSalePropertyV5FilterableStatus_decode: Query_forSalePropertyV5FilterableStatus_decode,
  forSalePropertyV5FilterableStatus_fromString: Query_forSalePropertyV5FilterableStatus_fromString,
  propertySearchSortOrder_decode: Query_propertySearchSortOrder_decode,
  propertySearchSortOrder_fromString: Query_propertySearchSortOrder_fromString,
  rentalPropertyFilterableStatus_decode: Query_rentalPropertyFilterableStatus_decode,
  rentalPropertyFilterableStatus_fromString: Query_rentalPropertyFilterableStatus_fromString,
  rentalPropertyTypeEnumV5_decode: Query_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: Query_rentalPropertyTypeEnumV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

let convertFragment = PropertiesPageRelayForSale_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertiesPageRelayForSale_query_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertiesPageRelayForSale_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertiesPageRelayForSale_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertiesPageRelayForSale_query_graphql.node, convertFragment, fRef);
}

let makeRefetchVariables = PropertiesPageRelayRefetchQuery_graphql.Types.makeRefetchVariables;

let convertRefetchVariables = PropertiesPageRelayRefetchQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(PropertiesPageRelayForSale_query_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

let ForSaleQueryFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable
};

let convertFragment$1 = PropertiesPageRelayInventory_query_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertiesPageRelayInventory_query_graphql.node, convertFragment$1, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertiesPageRelayInventory_query_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertiesPageRelayInventory_query_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertiesPageRelayInventory_query_graphql.node, convertFragment$1, fRef);
}

let makeRefetchVariables$1 = PropertiesPageRelayInventoryRefetchQuery_graphql.Types.makeRefetchVariables;

let convertRefetchVariables$1 = PropertiesPageRelayInventoryRefetchQuery_graphql.Internal.convertVariables;

function useRefetchable$1(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(PropertiesPageRelayInventory_query_graphql.node, convertFragment$1, convertRefetchVariables$1, fRef);
}

let InventoryQueryFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1,
  makeRefetchVariables: makeRefetchVariables$1,
  convertRefetchVariables: convertRefetchVariables$1,
  useRefetchable: useRefetchable$1
};

let convertFragment$2 = PropertiesPageRelayRental_query_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertiesPageRelayRental_query_graphql.node, convertFragment$2, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertiesPageRelayRental_query_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertiesPageRelayRental_query_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertiesPageRelayRental_query_graphql.node, convertFragment$2, fRef);
}

let makeRefetchVariables$2 = PropertiesPageRelayRentalRefetchQuery_graphql.Types.makeRefetchVariables;

let convertRefetchVariables$2 = PropertiesPageRelayRentalRefetchQuery_graphql.Internal.convertVariables;

function useRefetchable$2(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(PropertiesPageRelayRental_query_graphql.node, convertFragment$2, convertRefetchVariables$2, fRef);
}

let RentalQueryFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$3,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2,
  makeRefetchVariables: makeRefetchVariables$2,
  convertRefetchVariables: convertRefetchVariables$2,
  useRefetchable: useRefetchable$2
};

let convertVariables$1 = PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.Internal.convertVariables;

let convertResponse$1 = PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables$1, PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$4 = RescriptRelay_Mutation.useMutation(convertVariables$1, PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let RecordEventMutation_forSalePropertyTypeEnumV5_decode = PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let RecordEventMutation_forSalePropertyTypeEnumV5_fromString = PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let RecordEventMutation_forSalePropertyV5FilterableStatus_decode = PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.Utils.forSalePropertyV5FilterableStatus_decode;

let RecordEventMutation_forSalePropertyV5FilterableStatus_fromString = PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.Utils.forSalePropertyV5FilterableStatus_fromString;

let RecordEventMutation_propertySearchSortOrder_decode = PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.Utils.propertySearchSortOrder_decode;

let RecordEventMutation_propertySearchSortOrder_fromString = PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.Utils.propertySearchSortOrder_fromString;

let RecordEventMutation_rentalPropertyFilterableStatus_decode = PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.Utils.rentalPropertyFilterableStatus_decode;

let RecordEventMutation_rentalPropertyFilterableStatus_fromString = PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.Utils.rentalPropertyFilterableStatus_fromString;

let RecordEventMutation_rentalPropertyTypeEnumV5_decode = PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let RecordEventMutation_rentalPropertyTypeEnumV5_fromString = PropertiesPageRelay_RecordPropertySearchEventMutation_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let RecordEventMutation = {
  forSalePropertyTypeEnumV5_decode: RecordEventMutation_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: RecordEventMutation_forSalePropertyTypeEnumV5_fromString,
  forSalePropertyV5FilterableStatus_decode: RecordEventMutation_forSalePropertyV5FilterableStatus_decode,
  forSalePropertyV5FilterableStatus_fromString: RecordEventMutation_forSalePropertyV5FilterableStatus_fromString,
  propertySearchSortOrder_decode: RecordEventMutation_propertySearchSortOrder_decode,
  propertySearchSortOrder_fromString: RecordEventMutation_propertySearchSortOrder_fromString,
  rentalPropertyFilterableStatus_decode: RecordEventMutation_rentalPropertyFilterableStatus_decode,
  rentalPropertyFilterableStatus_fromString: RecordEventMutation_rentalPropertyFilterableStatus_fromString,
  rentalPropertyTypeEnumV5_decode: RecordEventMutation_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: RecordEventMutation_rentalPropertyTypeEnumV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation,
  use: use$4
};

function PropertiesPageRelay$Page(props) {
  let defaultAreas = props.defaultAreas;
  let initiallySelectedAreas = props.initiallySelectedAreas;
  let match = PropertiesPageRelayQueryParams.use();
  let params = match[0];
  let developmentsEnabled = FeaturesV3.useIsDevelopmentsEnabled() === true;
  let useNewPropertiesUpdatedSort = FeaturesV3.useFeatureFlipper("UseNewPropertiesUpdatedSort") === "on";
  let match$1 = React.useState(() => PropertiesPageRelayQueryParams.Params.transformParamsForApi(useNewPropertiesUpdatedSort, params));
  let initialParams = match$1[0];
  let match$2 = React.useState(() => {
    if (initiallySelectedAreas.length !== 0) {
      return initiallySelectedAreas;
    } else {
      return Stdlib_Option.getOr(defaultAreas, []);
    }
  });
  let selectedAreas = match$2[0];
  let showPropertyDetails = UserSession.useShouldShowPropertyDetails(undefined);
  let match$3 = use$4();
  let recordPropertySearchEvent = match$3[0];
  let isImpersonated = AuthSession.useIsImpersonated();
  let usesForSaleInventory = params => {
    if (params.rentalMode) {
      return false;
    } else {
      return developmentsEnabled;
    }
  };
  let recordPropertySearchEvent$1 = params => {
    if (!isImpersonated) {
      recordPropertySearchEvent({
        input: {
          after: params.after,
          areaIds: params.areaIds,
          before: params.before,
          forSalePropertyTypes: params.forSalePropertyTypes,
          forSaleStatuses: params.forSaleStatuses,
          keywords: params.keywords,
          maxBeds: params.maxBeds,
          maxPrice: params.maxPrice,
          minBeds: params.minBeds,
          minPrice: params.minPrice,
          occurredAt: Scalars.DateTime.fromJsDate(new Date()),
          offMlsOnly: params.offMlsOnly,
          rentalMode: params.rentalMode,
          rentalPropertyTypes: params.rentalPropertyTypes,
          rentalStatuses: params.rentalStatuses,
          sortOrder: params.sortOrder
        }
      }, undefined, undefined, undefined, undefined, undefined, undefined);
      return;
    }
  };
  React.useEffect(() => {
    recordPropertySearchEvent$1(initialParams);
  }, [initialParams]);
  let match$4 = React.useState(() => selectedAreas);
  let initialUseForSaleInventory = usesForSaleInventory(initialParams);
  let data = use({
    after: initialParams.after,
    areaIds: match$4[0].map(v => v.id),
    before: initialParams.before,
    first: initialParams.first,
    forSalePropertyTypes: initialParams.forSalePropertyTypes,
    forSaleStatuses: initialParams.forSaleStatuses,
    keywords: initialParams.keywords,
    last: initialParams.last,
    maxBeds: initialParams.maxBeds,
    maxPrice: initialParams.maxPrice,
    minBeds: initialParams.minBeds,
    minPrice: initialParams.minPrice,
    offMlsOnly: initialParams.offMlsOnly,
    rentalMode: initialParams.rentalMode,
    rentalPropertyTypes: initialParams.rentalPropertyTypes,
    rentalStatuses: initialParams.rentalStatuses,
    sortOrder: initialParams.sortOrder,
    useForSaleInventory: initialUseForSaleInventory,
    useForSaleProperties: !initialParams.rentalMode && !initialUseForSaleInventory
  }, undefined, undefined, undefined);
  let match$5 = React.useTransition();
  let startTransition = match$5[1];
  let isRefetching = match$5[0];
  let match$6 = useRefetchable(data.fragmentRefs);
  let refetchForSale = match$6[1];
  let forSaleData = match$6[0];
  let match$7 = useRefetchable$1(data.fragmentRefs);
  let refetchInventory = match$7[1];
  let inventoryData = match$7[0];
  let match$8 = useRefetchable$2(data.fragmentRefs);
  let refetchRental = match$8[1];
  let rentalData = match$8[0];
  let refetch = (modeOpt, after, before, paramSetter) => {
    let mode = modeOpt !== undefined ? modeOpt : "replace";
    let newrecord = {...paramSetter(PropertiesPageRelayQueryParams.getCurrentParams())};
    newrecord.before = before;
    newrecord.after = after;
    let paramsReadyForApi = PropertiesPageRelayQueryParams.Params.transformParamsForApi(useNewPropertiesUpdatedSort, newrecord);
    recordPropertySearchEvent$1(paramsReadyForApi);
    Scroll.scrollToTop();
    if (paramsReadyForApi.rentalMode) {
      startTransition(() => {
        refetchRental(makeRefetchVariables$2(Primitive_option.some(paramsReadyForApi.after), Stdlib_Option.getOr(Stdlib_Option.orElse(paramsReadyForApi.areaIds, Stdlib_Option.map(defaultAreas, xs => xs.map(x => x.id))), []), Primitive_option.some(paramsReadyForApi.before), Primitive_option.some(paramsReadyForApi.first), Primitive_option.some(paramsReadyForApi.keywords), Primitive_option.some(paramsReadyForApi.last), Primitive_option.some(paramsReadyForApi.maxBeds), Primitive_option.some(paramsReadyForApi.maxPrice), Primitive_option.some(paramsReadyForApi.minBeds), Primitive_option.some(paramsReadyForApi.minPrice), Primitive_option.some(paramsReadyForApi.offMlsOnly), true, Primitive_option.some(paramsReadyForApi.rentalPropertyTypes), Primitive_option.some(paramsReadyForApi.rentalStatuses), Primitive_option.some(paramsReadyForApi.sortOrder)), undefined, undefined);
      });
    } else {
      let useForSaleInventory = usesForSaleInventory(paramsReadyForApi);
      startTransition(() => {
        if (useForSaleInventory) {
          refetchInventory(makeRefetchVariables$1(Primitive_option.some(paramsReadyForApi.after), Stdlib_Option.getOr(Stdlib_Option.orElse(paramsReadyForApi.areaIds, Stdlib_Option.map(defaultAreas, xs => xs.map(x => x.id))), []), Primitive_option.some(paramsReadyForApi.before), Primitive_option.some(paramsReadyForApi.first), Primitive_option.some(paramsReadyForApi.forSalePropertyTypes), Primitive_option.some(paramsReadyForApi.forSaleStatuses), Primitive_option.some(paramsReadyForApi.keywords), Primitive_option.some(paramsReadyForApi.last), Primitive_option.some(paramsReadyForApi.maxBeds), Primitive_option.some(paramsReadyForApi.maxPrice), Primitive_option.some(paramsReadyForApi.minBeds), Primitive_option.some(paramsReadyForApi.minPrice), Primitive_option.some(paramsReadyForApi.offMlsOnly), Primitive_option.some(paramsReadyForApi.sortOrder), true), undefined, undefined);
        } else {
          refetchForSale(makeRefetchVariables(Primitive_option.some(paramsReadyForApi.after), Stdlib_Option.getOr(Stdlib_Option.orElse(paramsReadyForApi.areaIds, Stdlib_Option.map(defaultAreas, xs => xs.map(x => x.id))), []), Primitive_option.some(paramsReadyForApi.before), Primitive_option.some(paramsReadyForApi.first), Primitive_option.some(paramsReadyForApi.forSalePropertyTypes), Primitive_option.some(paramsReadyForApi.forSaleStatuses), Primitive_option.some(paramsReadyForApi.keywords), Primitive_option.some(paramsReadyForApi.last), Primitive_option.some(paramsReadyForApi.maxBeds), Primitive_option.some(paramsReadyForApi.maxPrice), Primitive_option.some(paramsReadyForApi.minBeds), Primitive_option.some(paramsReadyForApi.minPrice), Primitive_option.some(paramsReadyForApi.offMlsOnly), Primitive_option.some(paramsReadyForApi.sortOrder), true), undefined, undefined);
        }
      });
    }
    PropertiesPageRelayQueryParams.setQueryParamsInURL(mode, param => newrecord);
  };
  let useForSaleInventory = !params.rentalMode && developmentsEnabled;
  let match$9 = params.rentalMode;
  let match$10 = rentalData.searchRentalProperties;
  let match$11 = forSaleData.searchForSaleProperties;
  let match$12 = inventoryData.searchForSaleInventory;
  let totalCount;
  if (match$9) {
    if (match$10 !== undefined) {
      let totalCount$1 = match$10.totalCount;
      totalCount = totalCount$1 !== undefined ? totalCount$1 : 0;
    } else {
      totalCount = 0;
    }
  } else {
    let exit = 0;
    if (match$12 !== undefined) {
      let totalCount$2 = match$12.totalCount;
      if (totalCount$2 !== undefined && useForSaleInventory) {
        totalCount = totalCount$2;
      } else {
        exit = 1;
      }
    } else {
      exit = 1;
    }
    if (exit === 1) {
      if (match$11 !== undefined) {
        let totalCount$3 = match$11.totalCount;
        totalCount = totalCount$3 !== undefined ? totalCount$3 : 0;
      } else {
        totalCount = 0;
      }
    }
  }
  let tmp;
  if (params.rentalMode) {
    let match$13 = rentalData.searchRentalProperties;
    let rentalItems;
    if (match$13 !== undefined) {
      let edges = match$13.edges;
      rentalItems = edges !== undefined ? Stdlib_Array.filterMap(edges, e => {
          if (e !== undefined) {
            return e.node;
          }
        }) : [];
    } else {
      rentalItems = [];
    }
    let tmp$1;
    if (isRefetching) {
      tmp$1 = JsxRuntime.jsx(Loader.make, {});
    } else if (rentalItems.length !== 0) {
      let match$14 = rentalData.searchRentalProperties;
      let prevCursor;
      if (match$14 !== undefined) {
        let match$15 = match$14.pageInfo;
        if (match$15.hasPreviousPage) {
          let startCursor = match$15.startCursor;
          prevCursor = startCursor !== undefined ? startCursor : undefined;
        } else {
          prevCursor = undefined;
        }
      } else {
        prevCursor = undefined;
      }
      let match$16 = rentalData.searchRentalProperties;
      let nextCursor;
      if (match$16 !== undefined) {
        let match$17 = match$16.pageInfo;
        let endCursor = match$17.endCursor;
        nextCursor = endCursor !== undefined && match$17.hasNextPage ? endCursor : undefined;
      } else {
        nextCursor = undefined;
      }
      tmp$1 = JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              showPropertyDetails ? null : JsxRuntime.jsx(PropertyPage__FreePlanUpgradeBox.make, {}),
              JsxRuntime.jsx("ul", {
                children: rentalItems.map(item => JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx(RentalPropertySearchResult.make, {
                    property: item.fragmentRefs
                  }),
                  className: "col-span-1 contents"
                }, item.id)),
                className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4"
              })
            ],
            className: "flex flex-col gap-4"
          }),
          JsxRuntime.jsx(PropertiesPageRelaySharedComponents.PaginationBox.make, {
            refetch: refetch,
            prevCursor: prevCursor,
            nextCursor: nextCursor,
            params: params
          })
        ],
        className: "flex flex-col gap-6"
      });
    } else {
      tmp$1 = JsxRuntime.jsx(SearchPagesSharedComponents.NoMatches.make, {
        text: "No properties match your search right now."
      });
    }
    tmp = JsxRuntime.jsx("div", {
      children: tmp$1
    });
  } else {
    let match$18 = forSaleData.searchForSaleProperties;
    let forSaleItems;
    if (match$18 !== undefined) {
      let edges$1 = match$18.edges;
      forSaleItems = edges$1 !== undefined ? Stdlib_Array.filterMap(edges$1, e => Stdlib_Option.map(e, e => e.node)) : [];
    } else {
      forSaleItems = [];
    }
    if (useForSaleInventory) {
      let match$19 = inventoryData.searchForSaleInventory;
      let inventoryItems;
      if (match$19 !== undefined) {
        let edges$2 = match$19.edges;
        inventoryItems = edges$2 !== undefined ? Stdlib_Array.filterMap(edges$2, e => Stdlib_Option.map(e, e => e.node)) : [];
      } else {
        inventoryItems = [];
      }
      if (isRefetching) {
        tmp = JsxRuntime.jsx(Loader.make, {});
      } else if (inventoryItems.length !== 0) {
        let match$20 = inventoryData.searchForSaleInventory;
        let prevCursor$1;
        if (match$20 !== undefined) {
          let match$21 = match$20.pageInfo;
          if (match$21.hasPreviousPage) {
            let startCursor$1 = match$21.startCursor;
            prevCursor$1 = startCursor$1 !== undefined ? startCursor$1 : undefined;
          } else {
            prevCursor$1 = undefined;
          }
        } else {
          prevCursor$1 = undefined;
        }
        let match$22 = inventoryData.searchForSaleInventory;
        let nextCursor$1;
        if (match$22 !== undefined) {
          let match$23 = match$22.pageInfo;
          let endCursor$1 = match$23.endCursor;
          nextCursor$1 = endCursor$1 !== undefined && match$23.hasNextPage ? endCursor$1 : undefined;
        } else {
          nextCursor$1 = undefined;
        }
        tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                showPropertyDetails ? null : JsxRuntime.jsx(PropertyPage__FreePlanUpgradeBox.make, {}),
                JsxRuntime.jsx(SearchPagesSharedComponents.ResultsInfo.make, {
                  text: "Showing broadcast properties and new developments",
                  helperIconText: "Add your buyer to get matched with quiet sellers"
                }),
                JsxRuntime.jsx("ul", {
                  children: inventoryItems.map(item => {
                    switch (item.__typename) {
                      case "DevelopmentProject" :
                        return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
                          FallbackComponent: _error => null,
                          children: JsxRuntime.jsx("li", {
                            children: JsxRuntime.jsx(DevelopmentProjectSearchResult.make, {
                              project: item.fragmentRefs
                            }),
                            className: "col-span-1 contents"
                          }),
                          onError: error => Sentry.captureException(error, "PropertiesPageRelay.res", undefined, undefined, undefined)
                        }, `development-project-` + item.id);
                      case "DevelopmentProjectSampleUnit" :
                        return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
                          FallbackComponent: _error => null,
                          children: JsxRuntime.jsx("li", {
                            children: JsxRuntime.jsx(DevelopmentUnitSearchResult.make, {
                              unit: item.fragmentRefs
                            }),
                            className: "col-span-1 contents"
                          }),
                          onError: error => Sentry.captureException(error, "PropertiesPageRelay.res", undefined, undefined, undefined)
                        }, `development-unit-` + item.id);
                      case "ForSalePropertyV5" :
                        return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
                          FallbackComponent: _error => null,
                          children: JsxRuntime.jsx("li", {
                            children: JsxRuntime.jsx(ForSalePropertySearchResult.make, {
                              property: item.fragmentRefs
                            }),
                            className: "col-span-1 contents"
                          }),
                          onError: error => Sentry.captureException(error, "PropertiesPageRelay.res", undefined, undefined, undefined)
                        }, `property-` + item.id);
                      case "__unselected" :
                        return UnselectedUnionMemberError.raise(`Unexpected searchForSaleInventory node "` + item._0 + `"`);
                    }
                  }),
                  className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4"
                })
              ],
              className: "flex flex-col gap-4"
            }),
            JsxRuntime.jsx(PropertiesPageRelaySharedComponents.PaginationBox.make, {
              refetch: refetch,
              prevCursor: prevCursor$1,
              nextCursor: nextCursor$1,
              params: params
            })
          ],
          className: "flex flex-col gap-6"
        });
      } else {
        tmp = JsxRuntime.jsx(SearchPagesSharedComponents.NoMatches.make, {
          text: "No properties match your search right now."
        });
      }
    } else if (isRefetching) {
      tmp = JsxRuntime.jsx(Loader.make, {});
    } else if (forSaleItems.length !== 0) {
      let match$24 = forSaleData.searchForSaleProperties;
      let prevCursor$2;
      if (match$24 !== undefined) {
        let match$25 = match$24.pageInfo;
        if (match$25.hasPreviousPage) {
          let startCursor$2 = match$25.startCursor;
          prevCursor$2 = startCursor$2 !== undefined ? startCursor$2 : undefined;
        } else {
          prevCursor$2 = undefined;
        }
      } else {
        prevCursor$2 = undefined;
      }
      let match$26 = forSaleData.searchForSaleProperties;
      let nextCursor$2;
      if (match$26 !== undefined) {
        let match$27 = match$26.pageInfo;
        let endCursor$2 = match$27.endCursor;
        nextCursor$2 = endCursor$2 !== undefined && match$27.hasNextPage ? endCursor$2 : undefined;
      } else {
        nextCursor$2 = undefined;
      }
      tmp = JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              showPropertyDetails ? null : JsxRuntime.jsx(PropertyPage__FreePlanUpgradeBox.make, {}),
              JsxRuntime.jsx(SearchPagesSharedComponents.ResultsInfo.make, {
                text: "Showing broadcast properties only",
                helperIconText: "Add your buyer to get matched with quiet sellers"
              }),
              JsxRuntime.jsx("ul", {
                children: forSaleItems.map(item => JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
                  FallbackComponent: _error => null,
                  children: JsxRuntime.jsx("li", {
                    children: JsxRuntime.jsx(ForSalePropertySearchResult.make, {
                      property: item.fragmentRefs
                    }),
                    className: "col-span-1 contents"
                  }),
                  onError: error => Sentry.captureException(error, "PropertiesPageRelay.res", undefined, undefined, undefined)
                }, item.id)),
                className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4"
              })
            ],
            className: "flex flex-col gap-4"
          }),
          JsxRuntime.jsx(PropertiesPageRelaySharedComponents.PaginationBox.make, {
            refetch: refetch,
            prevCursor: prevCursor$2,
            nextCursor: nextCursor$2,
            params: params
          })
        ],
        className: "flex flex-col gap-6"
      });
    } else {
      tmp = JsxRuntime.jsx(SearchPagesSharedComponents.NoMatches.make, {
        text: "No properties match your search right now."
      });
    }
  }
  return JsxRuntime.jsxs(MarkupHelpers.Container.make, {
    children: [
      JsxRuntime.jsx(PageViews.RecordPageView.make, {
        page: PageViews.Page.makePropertiesPage()
      }),
      JsxRuntime.jsx(PageTitle.make, {
        title: "Properties"
      }),
      JsxRuntime.jsx(VisuallyHidden, {
        children: "Properties on TAN",
        _as: "h1"
      }),
      JsxRuntime.jsx(PropertiesPageRelayControls.make, {
        defaultAreas: defaultAreas,
        selectedAreas: selectedAreas,
        totalCount: totalCount,
        isRefetching: isRefetching,
        refetch: refetch,
        setSelectedAreas: match$2[1]
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(React.Suspense, {
          children: tmp,
          fallback: JsxRuntime.jsx(Loader.make, {})
        }),
        className: "py-4"
      })
    ]
  });
}

let Page = {
  RecordEventMutation: RecordEventMutation,
  make: PropertiesPageRelay$Page
};

let convertVariables$2 = PropertiesPageRelayWrapperQuery_graphql.Internal.convertVariables;

let convertResponse$2 = PropertiesPageRelayWrapperQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$2 = PropertiesPageRelayWrapperQuery_graphql.Internal.convertWrapRawResponse;

let use$5 = RescriptRelay_Query.useQuery(convertVariables$2, PropertiesPageRelayWrapperQuery_graphql.node, convertResponse$2);

let useLoader$1 = RescriptRelay_Query.useLoader(convertVariables$2, PropertiesPageRelayWrapperQuery_graphql.node, prim => prim);

let usePreloaded$1 = RescriptRelay_Query.usePreloaded(PropertiesPageRelayWrapperQuery_graphql.node, convertResponse$2, prim => prim);

let fetch$1 = RescriptRelay_Query.fetch_(PropertiesPageRelayWrapperQuery_graphql.node, convertResponse$2, convertVariables$2);

let fetchPromised$1 = RescriptRelay_Query.fetchPromised(PropertiesPageRelayWrapperQuery_graphql.node, convertResponse$2, convertVariables$2);

let retain$1 = RescriptRelay_Query.retain(PropertiesPageRelayWrapperQuery_graphql.node, convertVariables$2);

let WrapperQuery = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  use: use$5,
  useLoader: useLoader$1,
  usePreloaded: usePreloaded$1,
  fetch: fetch$1,
  fetchPromised: fetchPromised$1,
  retain: retain$1
};

function PropertiesPageRelay$WithLoggedInAgent(props) {
  let match = PropertiesPageRelayQueryParams.use();
  let params = match[0];
  let match$1 = React.useState(() => Stdlib_Option.getOr(params.areaIds, []));
  let initiallySelectedAreaIds = match$1[0];
  let shouldFetchDefaultAreas = UserSession.useChapterPreference("DefaultToChapterPreferenceAreas") === "ON";
  let shouldFetchAreas = initiallySelectedAreaIds.length !== 0;
  let data = use$5({
    areaIds: initiallySelectedAreaIds,
    fetchAreas: shouldFetchAreas,
    fetchDefaultAreas: shouldFetchDefaultAreas
  }, !shouldFetchDefaultAreas && !shouldFetchAreas ? "store-only" : "store-or-network", undefined, undefined);
  let match$2 = data.currentChapterV5;
  let defaultAreas = match$2 !== undefined ? match$2.notificationPreferences.defaultPropertyNotificationAreas.map(v => ({
      id: v.id,
      label: v.label
    })) : undefined;
  let initiallySelectedAreas = Stdlib_Array.keepSome(Stdlib_Option.getOr(data.areas, []));
  return JsxRuntime.jsx(PropertiesPageRelay$Page, {
    initiallySelectedAreas: initiallySelectedAreas.map(v => ({
      id: v.id,
      label: v.label
    })),
    defaultAreas: defaultAreas
  });
}

let WithLoggedInAgent = {
  make: PropertiesPageRelay$WithLoggedInAgent
};

let defaultMessage = "There was a problem searching for properties. Please refresh or try again later.";

function PropertiesPageRelay$ErrorState(props) {
  let __message = props.message;
  let message = __message !== undefined ? __message : defaultMessage;
  return JsxRuntime.jsx(MarkupHelpers.Container.make, {
    children: JsxRuntime.jsx(ErrorComponent.make, {
      message: message
    })
  });
}

let ErrorState = {
  defaultMessage: defaultMessage,
  make: PropertiesPageRelay$ErrorState
};

function PropertiesPageRelay$default(props) {
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
    FallbackComponent: _error => JsxRuntime.jsx(PropertiesPageRelay$ErrorState, {}),
    children: JsxRuntime.jsx(LoggedInAgent.Provider.make, {
      children: JsxRuntime.jsx(PropertiesPageRelay$WithLoggedInAgent, {})
    }),
    onError: error => Sentry.captureException(error, "PropertiesPageRelay.res", undefined, undefined, undefined)
  });
}

let FreePlanUpgradeBox;

let QueryParams;

let $$default = PropertiesPageRelay$default;

exports.FreePlanUpgradeBox = FreePlanUpgradeBox;
exports.QueryParams = QueryParams;
exports.Query = Query;
exports.ForSaleQueryFragment = ForSaleQueryFragment;
exports.InventoryQueryFragment = InventoryQueryFragment;
exports.RentalQueryFragment = RentalQueryFragment;
exports.Page = Page;
exports.WrapperQuery = WrapperQuery;
exports.WithLoggedInAgent = WithLoggedInAgent;
exports.ErrorState = ErrorState;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
